module.exports = ".edit-flush .ccc-flush {\n  display: inline-block;\n}\n.edit-flush .edit-flush-btn {\n  margin: 25px 2px 2px;\n}\n.edit-flush #company-select-to-impersonate {\n  display: block;\n  width: 100%;\n}\n.edit-flush #company-select-to-impersonate /deep/ .dropdown {\n  display: block;\n  margin-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/flush/flush.less
// module id = ./src/app/management/components/flush/flush.less
// module chunks = main